import { ITab } from "@koomzo/coremodel";
import { Component, OnInit } from "@angular/core";
import { NavController, MenuController } from "@ionic/angular";
@Component({
  selector: "app-home",
  templateUrl: "./home.page.html",
  styleUrls: ["./home.page.scss"],
})
export class HomePage implements OnInit {
  tabList: ITab[];

  constructor(private menu: MenuController, private navCtrl: NavController) {
    // this.menu.enable(false);
    // this.menu.swipeEnable(false);
  }

  ngOnInit() {}

  onClick(): void {
    console.log("coming soon...");
  }
}
